import { capitalize, ToggleButton, ToggleButtonGroup } from "@mui/material";
import MuiButton from "@mui/material/Button";
import i18next from "i18next";
import { useDispatch } from "react-redux";
import BasicInput from "../components/BasicInput";
import FieldTitle from "../components/FieldTitle";
import { setWatchLocation } from "../state/map/mapSlice";
import { constants } from "../utils";

import AddLocationAltRoundedIcon from "@mui/icons-material/AddLocationAltRounded";
import PinDropRoundedIcon from "@mui/icons-material/PinDropRounded";
import TravelExploreRoundedIcon from "@mui/icons-material/TravelExploreRounded";
import { SELECT_LOCATION_MODE } from "../utils/constants";

const AddLocationButtonsGroup = ({
	location,
	setLocation,
	setSelectingLocation,
	setSelectLocationMode,
	selectLocationMode,
	errors,
	showValue,
	creatingLocation = false,
}) => {
	const dispatch = useDispatch();

	const getIcon = () => {
		switch (selectLocationMode) {
			case constants.SELECT_LOCATION_MODE.locationAdd:
				return <AddLocationAltRoundedIcon className="text-primary" />;
			case constants.SELECT_LOCATION_MODE.locationSearch:
				return <TravelExploreRoundedIcon className="text-primary" />;
			case constants.SELECT_LOCATION_MODE.enterLatitudeLongitude:
				return <PinDropRoundedIcon className="text-primary" />;
			default:
				break;
		}
	};

	const handleOnChangeLocationInput = (value, isLat) => {
		const newCoordinates = location.coordinates ?? { lat: "", lng: "" };

		if (isLat) newCoordinates.lat = value;
		else newCoordinates.lng = value;
		setLocation({ ...location, coordinates: newCoordinates });
	};

	const handleInputChange = (value, isLat) => {
		const regex = /^-?\d*\.?\d*$/;
		if (regex.test(value)) {
			handleOnChangeLocationInput(value, isLat);
		}
	};

	return (
		<>
			{!showValue && (
				<>
					<FieldTitle label={i18next.t("location") + "*"} re />
					<ToggleButtonGroup className="d-flex " value={selectLocationMode}>
						{[
							SELECT_LOCATION_MODE.enterLatitudeLongitude,
							...(creatingLocation ? [] : [SELECT_LOCATION_MODE.locationAdd]),
							SELECT_LOCATION_MODE.locationSearch,
						].map((text) => (
							<ToggleButton
								key={text}
								data-testid={text + "-button-group"}
								onChange={() => {
									setSelectLocationMode(text);
									setSelectingLocation(true);

									if (text != SELECT_LOCATION_MODE.locationSearch) {
										dispatch(setWatchLocation(true));
									}
								}}
								style={{ textTransform: "none" }}
								value={text}
								className="px-3"
								size="small"
							>
								{capitalize(i18next.t(text))}
							</ToggleButton>
						))}
					</ToggleButtonGroup>
				</>
			)}
			<div className="d-flex">
				{(selectLocationMode == constants.SELECT_LOCATION_MODE.locationAdd ||
					selectLocationMode == constants.SELECT_LOCATION_MODE.locationSearch) &&
					location.name && (
						<BasicInput
							label={i18next.t("name")}
							value={location.name}
							onChange={(e) => setLocation({ ...location, name: e.target.value })}
							error={errors.name}
							className="mt-0 me-3"
							datatestid="name-input"
							showValue={showValue}
						/>
					)}
				<BasicInput
					label={i18next.t("latitude")}
					value={location?.coordinates?.lat}
					onChange={(e) => handleInputChange(e.target.value, true)}
					error={errors.location}
					className="mt-0"
					datatestid="lat-input"
					showValue={showValue}
				/>
				<BasicInput
					className="ms-3"
					label={i18next.t("longitude")}
					value={location?.coordinates?.lng}
					onChange={(e) => handleInputChange(e.target.value, false)}
					error={errors.location && !location?.coordinates?.lng}
					showValue={showValue}
					datatestid="lng-input"
				/>

				{selectLocationMode && !showValue && (
					<MuiButton
						onClick={() => {
							setSelectingLocation(true);
						}}
						className={"align-self-end ms-2 " + (errors.location ? "mb-4" : "")}
						sx={{ height: "2.9rem" }}
						data-testid={selectLocationMode + "button"}
					>
						{getIcon()}
					</MuiButton>
				)}
			</div>
		</>
	);
};

export default AddLocationButtonsGroup;
